import { Navigate, Outlet } from 'react-router-dom';
import { getRole, getToken } from './utils/session';

export const ProtectedRoute = ({ children, roles }) => {
  const userRole = getRole();

  if (!userRole || !getToken() || !roles.includes(userRole)) {
    return <Navigate to="/login" replace />;
  }
  return children ? children : <Outlet />;
};
